import { cn } from '@/lib/utils'

export type OdinFormDescriptionProps = {
  id?: string
  children: React.ReactNode
  className?: string
}

export function OdinFormDescription({ id, children, className }: OdinFormDescriptionProps) {
  return (
    <p id={id} className={cn('text-xs text-muted-foreground', className)}>
      {children}
    </p>
  )
}
